declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initPixel(pixelId: string) {
  if (initialized) return
  if (typeof window === 'undefined') return

  const f = window
  const b = document

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  b.head.appendChild(t)

  window.fbq('init', pixelId)
  initialized = true
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(data?: Record<string, any>) {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', data)
  }
}
